import clsx from "clsx";
import React from "react";
import { createPluggable } from "pluggable-react";
import InstanceIndex from "../../common/InstanceIndex/InstanceIndex";
import styles from "./NodePath.module.scss";

export interface NodePathProps {
  node?: {
    path?: string;
    description?: string;
  };
  showDescription?: boolean;
  indexOnly?: boolean;
  className?: string;
}

const DefaultNodePath = (props: NodePathProps) => {
  const { node, showDescription = true, indexOnly = false, className } = props;

  if (!node) return null;

  if (!node.path) {
    if (indexOnly) return null;
    return (
      <span className={clsx(styles.nodePath, className)} data-deci-node-path="true">
        {node.description}
      </span>
    );
  }

  const path = node.path.split("/");

  if (indexOnly) {
    return (
      <span className={clsx(styles.nodePath, className)} data-deci-node-path="true">
        <InstanceIndex path={path.slice(0, path.length - 1).join("/")} />
      </span>
    );
  }

  return (
    <span className={clsx(styles.nodePath, className)} data-deci-node-path="true">
      {path.map((p: string, index: number) => {
        if (index === path.length - 1) {
          return showDescription ? <span key={index} className={styles.description}>{node.description ?? p}</span> : null;
        }

        if (index % 2 === 0) {
          return (
            <React.Fragment key={index}>
              <span>{p}</span>
              <span className={styles.separator}>/</span>
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment key={index}>
              <InstanceIndex path={path.slice(0, index + 1).join("/")} />
              {(showDescription || (!showDescription && index !== path.length - 2)) && (
                <span className={styles.separator}>/</span>
              )}
            </React.Fragment>
          );
        }
      })}
    </span>
  );
};

const NodePath = createPluggable<NodePathProps>("deci.nodePath", DefaultNodePath);

export default NodePath;
